import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_TRIES = 6;
const POLL_MS = 2000;
const FINAL_FAILURES = ["expired", "failed"];

const nextState = (data, tries) => {
  if (data.payment_status === "paid") return "paid";
  if (FINAL_FAILURES.includes(data.payment_status)) return "error";
  return tries >= MAX_TRIES ? "pending" : null;
};

export const usePaymentStatus = (sessionId) => {
  const [state, setState] = useState(sessionId ? "checking" : "error");
  const [info, setInfo] = useState({});
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) return undefined;
    let active = true;
    let timer;
    const poll = async () => {
      let next = null;
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (!active) return;
        next = nextState(res.data, tries.current);
        if (next === "paid") setInfo(res.data);
      } catch {
        if (!active) return;
        if (tries.current >= MAX_TRIES) next = "error";
      }
      if (next) { setState(next); return; }
      tries.current += 1;
      timer = setTimeout(poll, POLL_MS);
    };
    poll();
    return () => { active = false; clearTimeout(timer); };
  }, [sessionId]);

  return { state, info };
};
